/**
 * HR app routes.
 * HR lives at /hr with two sub-sections: /hr/employees (HR Management)
 * and /contacts (Address Book, existing).
 */
const hrRoutes = [
  {
    path: "/hr",
    name: "HrHome",
    component: () => import("@/views/hr/HrHome.vue"),
    meta: { requiresAuth: true, app: "hr" },
  },
  {
    path: "/hr/employees",
    name: "HrEmployees",
    component: () => import("@/views/hr/HrEmployeesHome.vue"),
    meta: { requiresAuth: true, app: "hr-management" },
  },
];

export default hrRoutes;
